export const handleUsedVehicleParams = state => {
  const usedVehicleParams = {
    message: state.message,
  };

  return usedVehicleParams;
};
